import { PurchaseAreaListPage } from "@/features/purchase-area/pages/PurchaseAreaListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/purchase-area/")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["purchase_area.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PurchaseAreaListPage,
});
